import { Component, Input,ElementRef,ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import {ActivatedRoute} from '@angular/router';
import { Platform } from '@ionic/angular';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import {BaseModal} from '../../../../model/base';
import {WebParameterContext} from '../../../../model/common';
declare var app;
@Component({
  selector: 'app-walkingpath',
  templateUrl: './walkingpath.component.html',
  styleUrls: ['./walkingpath.component.scss']
})
export class WalkingpathComponent extends GridBaseCase{

  @ViewChild('nearbystoremap') map_container:ElementRef;
  @Input() data: any;//接收父组件的值
  constructor(
    private platform:Platform,
    private activaRouter: ActivatedRoute,
    private map:MapclientServiceService,
    private msg:MessageclientService,
    private http: HttpCustomerService,
    public base:BaseModal
  ) {super(); }
  ngOnChanges(){
    console.log("505"+this.data);
    
    }
  location() {
    let that = this;
    
      if(that.platform.is("cordova")){
        that.map.getGDCurrentPosition().then(data=>{
          that.msg.Loading("定位中...").then((loading)=>{
          that.map.getMaplocation(that.map_container.nativeElement).then(data=>{
            console.log(data);
            loading.dismiss();
            if(data.msg){
            }
            if(app.MARKER){//启用定位锚点
              that.getmendianlocation(data);
             }
          }).catch(error=>{  
            loading.dismiss();
            that.msg.Alert("定位失败,请切换网络,或者打开gps定位功能");
          });
          loading.present();
        });
        }).catch(err=>{
          that.msg.Alert("定位失败,请切换网络,或者打开gps定位功能");
          console.log(err,"定位失败或者没有权限");
        });
      }else{
        that.msg.Loading("定位中...").then((loading)=>{
        that.map.getMaplocation(that.map_container.nativeElement).then(data=>{
          console.log(data);
          loading.dismiss();
          if(data.msg){
          }
          if(app.MARKER){//启用定位锚点
            that.getmendianlocation(data);
           }
        }).catch(error=>{  
          loading.dismiss();
          that.msg.Alert("定位失败,请切换网络,或者打开gps定位功能");
        });
        loading.present();
      });
      }
     
}
getmendianlocation(data:any){
const that = this;
const maps = data.map;
const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
let body = new WebParameterContext();
body.ConfigName = "two_coordinate_distance";
body.OpType = "query";
body.ConfigType = "view";
// body.RowsPerPage = 2;
body.Client.PageName = PageName;
body.Client.ApiType = "Element";
body.Client.Name = that.element.name;
body.Client.ClientType = 2;
if (that.platform.is("android")) {
  body.Client.ClientType = 0;
} else if (that.platform.is("ios")) {
  body.Client.ClientType = 1;
}
body.RequestBody= JSON.stringify({"longitude":data.position.lng,"latitude":data.position.lat});
that.msg.Loading("正在努力的查找附近门店...").then((load)=>{
  that.http.post(app.DEFAULTURL, body).then(data => {
    load.dismiss();
    if (data.ResponseMessage.Success) {
      const option:Array<Array<string>>=[[]];
      data.Status.Datas.forEach((items,index)=>{
        let marker= that.map.drawMarker(items.a_longitude,items.a_latitude,items.a_MenDian);
          maps.add(marker);
      });
    }
  }).catch(error => {
    load.dismiss();
    that.msg.Show(error);
  });
  load.present();
}).catch((error)=>{
  console.log(error);
});
}
}
